/**
 * Historical combined-partnered Age Pension rate, by indexation date.
 * Used by the granny-flat reasonable-value test (rate as at the date the right was established).
 * Ported verbatim from frontend/src/constants/historicalPensionRates.js.
 */
export interface HistoricalPensionRateEntry {
    effectiveDate: string;
    basicAnnual: number;
    totalAnnual: number;
}

export const HISTORICAL_PARTNERED_PENSION_RATES: HistoricalPensionRateEntry[] = [
    { effectiveDate: '2020-09-20', basicAnnual: 33732.40, totalAnnual: 37013.60 },
    { effectiveDate: '2021-03-20', basicAnnual: 34034.00, totalAnnual: 37341.20 },
    { effectiveDate: '2021-09-20', basicAnnual: 34580.00, totalAnnual: 37923.60 },
    { effectiveDate: '2022-03-20', basicAnnual: 35308.00, totalAnnual: 38708.80 },
    { effectiveDate: '2022-09-20', basicAnnual: 36722.40, totalAnnual: 40237.60 },
    { effectiveDate: '2023-03-20', basicAnnual: 38079.60, totalAnnual: 41704.00 },
    { effectiveDate: '2023-09-20', basicAnnual: 39296.40, totalAnnual: 42988.40 },
    { effectiveDate: '2024-03-20', basicAnnual: 40003.60, totalAnnual: 43752.80 },
    { effectiveDate: '2024-09-20', basicAnnual: 41043.60, totalAnnual: 44855.20 },
    { effectiveDate: '2025-03-20', basicAnnual: 41210.00, totalAnnual: 45037.20 },
    { effectiveDate: '2025-09-20', basicAnnual: 42322.80, totalAnnual: 46202.00 },
    { effectiveDate: '2026-03-20', basicAnnual: 43128.80, totalAnnual: 47070.40 },
    { effectiveDate: '2026-09-20', basicAnnual: 44506.80, totalAnnual: 48516.00 }, // totalAnnual = current PENSION_RATES.couple
];

/** Which basis the granny-flat valuation uses. 'total' (default, matches worked example) or 'basic' (pending actuary). */
export const GRANNY_FLAT_PENSION_RATE_BASIS: 'total' | 'basic' = 'total';

/**
 * Combined annual partnered pension rate that applied on a given date (the most recent indexation ≤ date).
 */
export function getPartneredPensionRateAtDate(
    date: Date | string,
): { combinedAnnual: number; basis: string; effectiveDate: string } | null {
    const d = date instanceof Date ? date : new Date(date);
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return null;
    let match: HistoricalPensionRateEntry | null = null;
    for (const entry of HISTORICAL_PARTNERED_PENSION_RATES) {
        if (new Date(entry.effectiveDate) <= d) match = entry;
        else break;
    }
    if (!match) return null;
    const combinedAnnual = GRANNY_FLAT_PENSION_RATE_BASIS === 'basic' ? match.basicAnnual : match.totalAnnual;
    return { combinedAnnual, basis: GRANNY_FLAT_PENSION_RATE_BASIS, effectiveDate: match.effectiveDate };
}

export default HISTORICAL_PARTNERED_PENSION_RATES;
